import BaseUseCase from "../../../base_use_case.js";

class PublishProjectUseCase extends BaseUseCase {

  execute(identifier) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "post",
      url: `/api/v1/admin/projects/projects/${identifier}/publish`,
      data: {
        findBySlug: true
      },
    });
  }
}

const instance = new PublishProjectUseCase();
export default instance;